import { useState, useEffect } from "react";
import TextSkeleton from "../../components/SkeletonComponents/TextSkeleton";

const NotesInput = (props) => {
  const intialNotes = props.notes;
  const [notes, setNotes] = useState(props.notes || "");
  const isLoading = props.isLoading;

  useEffect(() => {
    setNotes(props.notes);
  }, [props.notes]);

  const handleNotesBlurred = () => {
    //Can remove onFocus from input once workout template page is optimistic
    if (notes !== intialNotes || props.needOnFocusEvent) {
      props.onNotesUpdated(notes);
    }
  };

  return (
    <div className="px-2 pt-0 pb-4">
      <label className="block text-sm font-medium text-gray-700">Notes</label>
      {!isLoading ? (
        <textarea
          id="notes"
          name="notes"
          tabIndex={-1}
          rows={4}
          autoComplete="off"
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-sm"
          placeholder={props.placeholder || ""}
          value={notes}
          onChange={(event) => {
            setNotes(event.target.value);
          }}
          onBlur={handleNotesBlurred}
          //Can remove onFocus from input once workout template page is optimistic
          onFocus={props.onFocus}
        />
      ) : (
        <TextSkeleton height="98px" className="w-full mt-1" />
      )}
    </div>
  );
};

export default NotesInput;
